var render, staticRenderFns
import script from "./UTitle.vue?vue&type=script&lang=js&"
export * from "./UTitle.vue?vue&type=script&lang=js&"
import style0 from "./UTitle.vue?vue&type=style&index=0&id=628c00ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628c00ee",
  null
  
)

export default component.exports